import React from "react";

import moment from "moment";
import { toast } from "react-toastify";

import { useAccessStatus } from "../../../../grace-period/hooks/useAccessStatus";
import { convertUtcToLocal } from "../../../../Common/utils/dateUtils";

import { ReactComponent as PDFIcon } from "../../../../../assets/images/environment/pdfIcon.svg";

export default function ReportFileCard({ file, onPreview }) {
  const { areResultsLocked } = useAccessStatus();
  const filePath = file.s3_report_path || "";
  const fileName = filePath ? filePath.split("/").pop() : "";
  const reportType = file.report_type || "";

  const handleSelectFile = () => {
    if (areResultsLocked) {
      return;
    }

    if (!filePath) {
      if (reportType === "partial") {
        toast.error("Failed to preview Partial Report");
      } else {
        toast.error("Unable to preview file");
      }
      return;
    }

    onPreview(file);
  };

  return (
    <div
      className={`prod-report-history-file-card${areResultsLocked ? " prod-report-history-file-card--locked" : ""}`}
      onClick={handleSelectFile}
    >
      <div className="pdf-icon-path">
        <PDFIcon width={14} height={14} />
        <span title={fileName}>{fileName}</span>
      </div>
      <div className="file-card-info">
        {reportType && <span className="file-card-type">{reportType}</span>}
        <span className="file-card-date">
          {moment(new Date(convertUtcToLocal(file.received_on))).format("DD MMM YYYY | hh:mm a")}
        </span>
      </div>
    </div>
  );
}
